export const __APP_NAME__ = "ServiceMe"